import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateConfigPagamentoUseCase } from "../../../presentation/useCases/create/create_config_pagamento_use_case";
import { ICreateItemMedicaoUseCase } from "../../../presentation/useCases/create/create_item_medicao_use_case";

// CreateItemMedicaoUseCase


export class CreateItemMedicaoUseCase implements ICreateItemMedicaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createItemMedicao( IdMedicaoTerceirizacao: number | null, IdProdutoServico: number | null, IdSubconta: number | null, Detalhamento: string | null, Quantidade: number | null, ValorUnitario: number | null, ValorTotal: number | null): Promise<void> {
    
    await this.repository.createItemMedicao(IdMedicaoTerceirizacao, IdProdutoServico, IdSubconta, Detalhamento, Quantidade, ValorUnitario, ValorTotal);
  }
}
